import React from "react";

import { DataContext, StateAndRef } from "../../types/common";
import { InvoiceState, InvoiceStatus } from "../../types/invoice";
import { emptyPromise } from "../../utils/common";

const InvoiceContext = React.createContext<
    DataContext<StateAndRef<InvoiceState>>
>({
    data: {
        ref: "",
        state: {
            data: {
                linearId: {
                    id: "",
                },
                createdAt: "",
                status: InvoiceStatus.CONTRACTOR_SUBMITTED,
                props: {
                    claimLinearId: {
                        id: "",
                    },
                    bankAccountDetails: {
                        id: "",
                        bankAccountHolderName: "",
                        bankAccountNumber: 0,
                        bankAccountNumberStr: "",
                        swiftAddress: "",
                        bankName: "",
                        registeredAddress: "",
                        currency: "",
                    },
                    amount: "",
                    documents: [],
                    developer: "",
                    mainContractor: "",
                    paymentIds: [],
                },
                lastChangedTime: "",
                comments: [],
            },
        },
    },
    mutate: emptyPromise,
});

export default InvoiceContext;
